import { ESourceControl } from '../../../../@xmcloud/types';
import {
	createCombinedProject,
	secondStep,
} from '../../../../@xmcloud/core/messages/en';
import { HeadingLg, ToggleStack } from '../../../shared-components';
import { IS_BYOC, LINK_ENV_TO_DEFAULT_BRANCH, REPOSITORY } from '../helpers';
import { foundationTemplateLearnMoreUrl } from '../../../../@xmcloud/utils/constants';
import {
	Stack,
	Tab,
	TabList,
	TabPanel,
	TabPanels,
	Text,
} from '@chakra-ui/react';
import { OLDExistingGithubConnection } from './OLDExistingGithubConnection';
import { OLDExistingADOConnection } from './OLDExistingADOConnection';
import { Microcopy } from './Text';
import { useCreateProject } from '../hooks';

const { combined, owncode } = createCombinedProject;
const { title, title2, usetemplate, useOwnCode, desc2, desc } = secondStep;
const { GitHub, ADO } = ESourceControl;

export const OLDSetupRepository: React.FC = () => {
	const {
		values: { provider, isByoc },
		setValues,
	} = useCreateProject();

	const isGithubConnection = provider === GitHub;
	const isADOConnection = provider === ADO;

	const pageTitle = isByoc ? title2 : title;
	const subTitle = isByoc ? desc2 : desc;

	return (
		<Stack>
			<HeadingLg text={pageTitle} pb="2" />
			<Text>{subTitle}</Text>
			<Stack pt="3" spacing={0}>
				<ToggleStack
					defaultIndex={isByoc ? 1 : 0}
					onChange={(index) => {
						setValues((prev) => ({
							...prev,
							[IS_BYOC]: index === 1,
							[LINK_ENV_TO_DEFAULT_BRANCH]: index === 0,
							[REPOSITORY]: '',
						}));
					}}
					isLazy
					panels={
						<TabPanels>
							<TabPanel p={0}>
								<Microcopy
									text={combined}
									href={foundationTemplateLearnMoreUrl}
								/>
								{isGithubConnection && (
									<OLDExistingGithubConnection />
								)}
								{isADOConnection && (
									<OLDExistingADOConnection />
								)}
							</TabPanel>
							<TabPanel p={0}>
								<Microcopy
									text={owncode}
									href={foundationTemplateLearnMoreUrl}
								/>
								{isGithubConnection && (
									<OLDExistingGithubConnection />
								)}
								{isADOConnection && (
									<OLDExistingADOConnection />
								)}
							</TabPanel>
						</TabPanels>
					}
				>
					<TabList>
						<Tab
							data-testid="use-xmcloud-template-btn"
							key="use-xmcloud-template-btn"
						>
							{usetemplate}
						</Tab>
						<Tab
							data-testid="use-own-code-btn"
							key="use-own-code-btn"
						>
							{useOwnCode}
						</Tab>
					</TabList>
				</ToggleStack>
			</Stack>
		</Stack>
	);
};
